import { useTracking } from '@change-corgi/core-react/tracking';

import { useHomepagePageData } from 'src/app/pages/homepage/pageContext';

type Tip = {
	title: string;
	guideLink: string;
};
type Result = ModelHookResult<
	{
		tips: readonly Tip[];
	},
	{
		onTipLinkClick: (url: string) => void;
	}
>;

export function useTipsAndGuides(): Result {
	const {
		data: { tips },
	} = useHomepagePageData();

	const track = useTracking();

	// Transform external URLs to internal paths for client-side routing
	// Temporary workaround as the FCM currently provides full URLs
	const transformedTips = tips.map((tip) => ({
		...tip,
		guideLink: tip.guideLink.replace(/^https?:\/\/[^/]+/, ''),
	}));

	return {
		data: { tips: transformedTips },
		actions: {
			onTipLinkClick: (url: string) => {
				void track('homepage_tips_and_guides_link_click', { url });
			},
		},
	};
}
